import { render, staticRenderFns } from "./InPlatformNotification.vue?vue&type=template&id=a2cf935e&scoped=true&"
import script from "./InPlatformNotification.vue?vue&type=script&lang=js&"
export * from "./InPlatformNotification.vue?vue&type=script&lang=js&"
import style0 from "./InPlatformNotification.vue?vue&type=style&index=0&id=a2cf935e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cf935e",
  null
  
)

export default component.exports